
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import AuthenticationService from "../../security/AuthenticationService";
import version from "../../version";
import notifications from "../../lib/notifications";
import { OrderModule, FacilityModule, SettingModule } from "@/store/modules";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import permissions from "@/security/permissions";
import moment from "moment";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";

@Component
export default class Navbar extends Vue {
  orderModule: OrderModule = getModule(OrderModule);
  faciltyModule: FacilityModule = getModule(FacilityModule);
  settingModule: SettingModule = getModule(SettingModule);
  barcodeSystemModule: BarcodeSystemModule = getModule(BarcodeSystemModule);
  manifestModule: ManifestModule = getModule(ManifestModule);
  searching: boolean = false;
  searchText: string = null;
  searchType: string = "CDS";
  truckFlag: string = process.env.VUE_APP_TRUCKS_ACTIVE;
  changePwdUrl: string = process.env.VUE_APP_AUTHORITY
    ? process.env.VUE_APP_AUTHORITY + "account/changepassword"
    : "";
  manageAccountUrl: string = process.env.VUE_APP_AUTHORITY
    ? process.env.VUE_APP_AUTHORITY + "account/manage"
    : "";
  appsUrl: string = process.env.VUE_APP_APPS_URL ? process.env.VUE_APP_APPS_URL : "";
  eLearningUrl: string = process.env.VUE_APP_ELEARNING_URL ? process.env.VUE_APP_ELEARNING_URL : "";

  @Prop({ default: {} })
  user: any;

  selectedSubmenu: any = null;

  @Prop({ default: false })
  displayNavigation: boolean;

  @Prop({ default: false })
  isLoggedIn: boolean;

  @Prop({ default: false })
  validUser: boolean;

  expand(e: any) {
    let subMenu = e.target.getAttribute("data-submenu");

    if(this.selectedSubmenu ===subMenu) {
      this.selectedSubmenu = null;
    } else {
      this.selectedSubmenu = subMenu;
    }
  }

  hideSubmenu(e: any) {
    if(this.selectedSubmenu == null)
      return;

    let target : any = e.target || e.srcElement;
    let parent : any = target.parentElement ?? target;

    if(!target.outerHTML.includes(this.selectedSubmenu) && !parent.outerHTML.includes("submenu")) {
      this.selectedSubmenu = null;
    }
  }

  get versionNumber(): string {
    return version.number;
  }

  get formattedSearchType(): string {
    switch (this.searchType) {
      case "CRN":
        return "CRN";
      case "REF":
        return "REF #";
      case "ZIP":
        return "Zip (Open Only)";
      case "TrackingNumber":
        return "Tracking #";
      case "ConsigneeName":
        return "Consignee Name (Open Only)";
      case "ConsigneePhone":
        return "Consignee Phone (Open Only)";
      default:
        return "SYS #";
    }
  }
  get actionsToDisplay() {
    let actions = this.$route.meta.actions;
    if (actions)
      return actions.filter(x => x.requiresPermission === undefined
        || this.hasPermission(x.requiresPermission)
        || this.hasPermission(x.requiresPermission, true));
  }


  isActionDisabled(item: any): boolean {
    if (item.requiresSelection && this.orderModule.selectedOrders.length === 0) return true;
    if (item.action == 'order/addOrderToTruckShortcutAction' && (this.orderModule.selectedOrders.some(x => x.orderType == 'WILL') || this.orderModule.currentOrder.orderType === "WILL")) return true;
    return false;
  }

  get isNewVersionAvailable() {
    if (!!this.settingModule.newVersionValue) {
      this.$cookies.set("version", this.settingModule.newVersionValue);
    }
    var lastVersionDateStr = localStorage.getItem("new-version-timestamp");
    if (!lastVersionDateStr) {
      return false;
    }
    var lastVersionDate = moment(lastVersionDateStr)
      .add(process.env.VUE_APP_DISPLAY_NEW_VERSION_IN_HOURS, "h")
      .isAfter(moment());
    return lastVersionDate;
  }

  get releaseNotesUrl() {
    return process.env.VUE_APP_RELEASE_NOTES_URL;
  }

  showAdvancedSearch() {
    this.orderModule.advancedSearchShortcutAction(null);
  }

  showDeliveryExport() {
    this.orderModule.deliveryExportModalShortcutAction();
  }

  showCompletedOrderExport() {
    this.orderModule.completedOrderExportModalShortcutAction();
  }

  showDocumentUpload() {
    this.orderModule.documentUploadModalShortcutAction();
  }

  showFacilitySavedOrderSearch() {
    this.faciltyModule.manageFacilitySavedSearchShortcutAction();
  }
  showBarcodeCurrentFacility() {
    this.barcodeSystemModule.barcodeSystemCurrentFacilityShortcutAction();
  }
  showNewManifest() {
    this.manifestModule.newManifestShortcutAction();
  }

  async search() {
    this.searchText = this.searchText? this.searchText.trim(): null;
    if (this.searchText && this.searchText !== "") {
      this.searching = true;
      await this.orderModule
        .loadQuickSearch({
          page: 1,
          text: this.searchText,
          type: this.searchType,
          quickSearch: true
        })
        .catch(ex => {
          notifications.error("Search", "Failed to execute search. Please try again.");
          console.warn(ex);
        })
        .finally(() => {
          this.searching = false;
          this.searchText = this.searchText.trim();
        });
    }
  }

  logout() {
    AuthenticationService.logout().then(() => {});
  }

  shortcutClicked(shortcut) {
    let selectedOrdersPayload = [this.$store.state.order.currentOrder];
    if (
      shortcut.action == "order/addOrderToTruckShortcutAction" &&
      this.$store.state.order.currentOrder.headerNumber === 0
    ) {
      selectedOrdersPayload = this.orderModule.selectedOrders;
    }

    this.$store.dispatch(shortcut.action, {
      selectedItems: selectedOrdersPayload
    });
  }

  setSearchType(value) {
    this.searchType = value;
  }

  barcodeFacilitySelected() {
    if(this.barcodeSystemModule.currentFacilityCode)
      return true;
    return false;
  }

  enableWarehousing() {
    if(this.barcodeFacilitySelected && this.barcodeSystemModule.warehouseFacilities){
      return  this.barcodeSystemModule.warehouseFacilities.some(x => x.facilityCode == this.barcodeSystemModule.currentFacilityCode);
    }
    return false;
  }
}
